// extracted by mini-css-extract-plugin
module.exports = {"information":"_5D2i0sWk","users":"_5D2Yr_30"};